module.exports = __webpack_public_path__ + "img/engine-status.7a94420e.svg";